/* istanbul ignore file */
import { useEffect, useLayoutEffect } from 'react';
import { checkIsClientSide } from 'core/common/utils/checkIsClientSide';

export const useIsomorphicLayoutEffect = checkIsClientSide() ? useLayoutEffect : useEffect;
